import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  labourData: [],
  pages: 0,
  total: 0,
  currentPage: 1
};

export default function getLabourList(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_REPORT_LABOUR_LIST_REQUEST:
      return {
        ...state,
        isfetching: true
      };
    case actionConstants.GET_REPORT_LABOUR_LIST_SUCCESS:
      if (action.payload.page === 1) {
        return {
          ...state,
          labourData: action.payload.docs,
          isfetching: false,
          success: action.payload.message,
          pages: action.payload.pages,
          total: action.payload.total,
          currentPage: action.payload.page
        };
      }
      return {
        ...state,
        labourData: [...state.labourData, ...action.payload.docs],
        isfetching: false,
        success: action.payload.message,
        pages: action.payload.pages,
      };
    case actionConstants.GET_REPORT_LABOUR_LIST_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        ...initialState
      };
    case actionConstants.RESET_ALL_REDUCERS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
